import PropTypes from "prop-types";

// eslint-disable-next-line import/prefer-default-export
export const ImageSourcesType = PropTypes.shape({
  "regular@1x": PropTypes.string,
  "regular@2x": PropTypes.string,
  "regular@3x": PropTypes.string,
});
